
export function fn_pos_mid(id){
	var box = document.getElementById(id);
	box.style.marginTop = -box.clientHeight / 2 + "px";
	box.style.marginLeft = -box.clientWidth / 2 + "px";
}


// WEBPACK FOOTER //
// ./src/assets/js/harvest.js